import { apiFetcher } from "./apiFetcher";

export const mobilizeiAppPublicationsService = {
    startAppPublication,
    finishAppPublication,
    prepareStore,
    registerIosDevice,
    iosCredentialsAuthStart,
    iosCredentialsSendSms,
    iosCredentialsVerify,
};

function iosCredentialsAuthStart(data) {
    return apiFetcher('app_publications/ios-credentials/auth/start', {
        method: 'POST',
        body: JSON.stringify(data),
    }).then(response => response);
}

function iosCredentialsSendSms(data) {
    return apiFetcher('app_publications/ios-credentials/auth/send-sms', {
        method: 'POST',
        body: JSON.stringify(data),
    }).then(response => response);
}

function iosCredentialsVerify(data) {
    return apiFetcher('app_publications/ios-credentials/auth/verify', {
        method: 'POST',
        body: JSON.stringify(data),
    }).then(response => response);
}

function prepareStore(data) {
    const url = `app_publications/prepare-store`;

    return apiFetcher(url, {
        method: "POST",
        body: JSON.stringify(data)
    }).then(response => response);
}

function startAppPublication(data) {
    const url = `app_publications`;

    return apiFetcher(url, {
        method: "POST",
        body: JSON.stringify(data)
    }).then(response => response);
}

function registerIosDevice(data) {
    return apiFetcher('app_publications/register-ios-device', {
        method: 'POST',
        body: JSON.stringify(data),
    }).then(response => response);
}

function finishAppPublication(publicationId) {
    const url = `app_publications/${publicationId}/finish`;

    return apiFetcher(url, {
        method: "POST",
    }).then(response => response);
}
